import { INSURER_CODES } from 'insurers/insurers'
import IrishLifeReport from './irishLife/IrishLifeReport'
import RoyalLondonReport from './royalLondon/RoyalLondonReport'

function ReportMapper({ insurerCode, ...props }) {  

    switch (insurerCode) {
        case INSURER_CODES.irishLife: return <IrishLifeReport {...props} />
        case INSURER_CODES.royalLondon: return <RoyalLondonReport {...props} />
        default: return null
    }
    
}

export default ReportMapper